import type { SipInfoMessage } from 'features/sip/interfaces';

export const messageToClearVPText: SipInfoMessage = [
  'application/sorenson',
  `00110000`,
];
